import React from 'react';
import SingleObjUploaderWithSelector from '../../../Mam/SingleObjUploaderWithSelector';
import Modal from '../../../../Modal/Modal';

const UIChooseImageModal = ({
  toggleModal,
  setImage,
}) => (
  <Modal handleClick={toggleModal} positionMiddle zIndex="5" singleUploader background="h-732 bg-black">
    <SingleObjUploaderWithSelector selectCallback={setImage} />
  </Modal>
)

export default UIChooseImageModal;